/* Sneaker-Vorlage: Produktseite - Galerie-Punkte, Größentabelle, Video-Bewertungen, Farbkacheln */
if (!customElements.get('carousel-dots')) {
  customElements.define('carousel-dots', class extends HTMLElement {
    connectedCallback() {
      const carousel = this.closest('.product-media-carousel');
      this.slider = carousel ? carousel.querySelector('.product-media-carousel__track') : null;
      if (!this.slider) return;
      this.slides = []; this.dots = []; this.io = null;
      this.build();
      this.mo = new MutationObserver(() => {
        const cur = this.getSlides();
        let changed = cur.length !== this.slides.length;
        if (!changed) for (let i = 0; i < cur.length; i++) if (cur[i] !== this.slides[i]) { changed = true; break; }
        if (changed) this.build();
      });
      this.mo.observe(this.slider, { childList: true });
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.mo) this.mo.disconnect(); }
    getSlides() { return Array.prototype.slice.call(this.slider.querySelectorAll('.product-media-carousel__slide')); }
    setActiveDot(idx) {
      this.dots.forEach((d, i) => { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
    }
    observe() {
      if (this.io) this.io.disconnect();
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.intersectionRatio > 0.5) { const i = this.slides.indexOf(e.target); if (i !== -1) this.setActiveDot(i); } });
      }, { root: this.slider, threshold: [0.5, 0.75, 0.99] });
      this.slides.forEach((s) => this.io.observe(s));
    }
    build() {
      this.slides = this.getSlides();
      if (!this.slides.length) return;
      this.innerHTML = '';
      this.dots = this.slides.map((slide, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-media-carousel__dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', String(idx + 1));
        dot.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }));
        this.appendChild(dot);
        return dot;
      });
      this.observe();
    }
  });
}
(function () {
  if (window.__yMainProduct) return;
  window.__yMainProduct = true;
  var prevFocus = null;
  function modalOf(id) { return document.getElementById(id); }
  function closeSize(m) {
    if (!m) return;
    m.classList.remove('is-open');
    document.body.style.overflow = '';
    var done = function () { m.hidden = true; if (prevFocus) prevFocus.focus(); };
    m.addEventListener('transitionend', done, { once: true });
    setTimeout(function () { if (!m.hidden && !m.classList.contains('is-open')) done(); }, 400);
  }
  function cvrOpen(uid, index) {
    var overlay = document.getElementById(uid + '-overlay'), pv = document.getElementById(uid + '-popup-video'), dataEl = document.getElementById(uid + '-data');
    if (!overlay || !pv || !dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sources = data[index]; if (!sources) return;
    pv.innerHTML = ''; pv.removeAttribute('src');
    sources.forEach(function (s) { if (!s.url) return; var el = document.createElement('source'); el.src = s.url; el.type = s.type; pv.appendChild(el); });
    pv.load(); pv.play().catch(function () {});
    overlay.classList.add('is-active'); document.body.style.overflow = 'hidden';
  }
  function cvrClose(uid) {
    var overlay = document.getElementById(uid + '-overlay'), pv = document.getElementById(uid + '-popup-video');
    if (overlay) overlay.classList.remove('is-active');
    if (pv) { pv.pause(); pv.innerHTML = ''; pv.removeAttribute('src'); }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-size-guide-open]');
    if (op) {
      var m = modalOf(op.getAttribute('aria-controls'));
      if (m) { e.preventDefault(); prevFocus = document.activeElement; m.hidden = false; m.offsetHeight; m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    var cl = e.target.closest('[data-size-guide-close]');
    if (cl) { closeSize(cl.closest('[data-size-guide-modal]')); return; }
    var co = e.target.closest('[data-cvr-open]');
    if (co) { cvrOpen(co.getAttribute('data-cvr-open'), co.getAttribute('data-cvr-index')); return; }
    var cc = e.target.closest('[data-cvr-close]');
    if (cc && (cc.classList.contains('cvr-close') || e.target === cc)) { cvrClose(cc.getAttribute('data-cvr-close')); return; }
    var sw = e.target.closest('.color-swatch__item');
    if (sw) {
      var track = sw.closest('.color-swatch__track');
      if (track) {
        track.querySelectorAll('.color-swatch__item').forEach(function (el) { el.classList.remove('color-swatch__item--active'); });
        sw.classList.add('color-swatch__item--active');
        var val = document.querySelector('[data-selected-color-value]');
        if (val && sw.title) val.textContent = sw.title;
      }
    }
    var ar = e.target.closest('.color-swatch__arrow');
    if (ar) {
      var t = ar.closest('.color-swatch__carousel-wrapper').querySelector('.color-swatch__track');
      t.scrollBy({ left: ar.classList.contains('color-swatch__arrow--prev') ? -220 : 220, behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var ov = document.querySelector('.cvr-overlay.is-active');
      if (ov) cvrClose(ov.id.replace('-overlay', ''));
      var sm = document.querySelector('[data-size-guide-modal].is-open');
      if (sm) closeSize(sm);
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('cvr-thumbnail')) { e.preventDefault(); e.target.click(); }
  });
  function updateArrows(track) {
    var w = track.closest('.color-swatch__carousel-wrapper'); if (!w) return;
    var p = w.querySelector('.color-swatch__arrow--prev'), n = w.querySelector('.color-swatch__arrow--next');
    var atStart = track.scrollLeft <= 2, atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (p) { p.disabled = atStart; p.classList.toggle('color-swatch__arrow--hidden', atStart); }
    if (n) { n.disabled = atEnd; n.classList.toggle('color-swatch__arrow--hidden', atEnd); }
  }
  function initTracks() {
    document.querySelectorAll('[data-variant-image-track]').forEach(function (t) {
      if (t.__yInit) return; t.__yInit = true;
      t.addEventListener('scroll', function () { updateArrows(t); }, { passive: true });
      var a = t.querySelector('.color-swatch__item--active');
      if (a) t.scrollLeft = a.offsetLeft - t.offsetLeft;
      updateArrows(t);
    });
  }
  function initVideos() {
    if (typeof IntersectionObserver === 'undefined') return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target.querySelector('video'); if (!v) return;
        if (en.isIntersecting) {
          var srcs = v.querySelectorAll('source[data-src]');
          if (srcs.length) { srcs.forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); }); v.load(); }
          v.play().catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('.cvr-thumbnail').forEach(function (t) { obs.observe(t); });
  }
  function init() { initTracks(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
